import { useState } from 'react';
import SectionHeading from '@/pages/home/components/SectionHeading';
import { todayStories } from '@/mocks/home';

type Story = (typeof todayStories)[number];

function StoryCard({ story }: { story: Story }) {
  const [liked, setLiked] = useState(false);
  const [saved, setSaved] = useState(false);

  return (
    <article className="group flex flex-col">
      <div className="relative h-[240px] w-full overflow-hidden rounded-lg border border-background-200/80 md:h-[280px]">
        <img
          src={story.image}
          alt={story.title}
          title="今日猛料 最新爆料"
          className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 to-transparent" />
        <span className="absolute left-4 top-4 rounded-full bg-background-50/95 px-3 py-1 font-label text-[11px] tracking-editorial text-primary-700">
          {story.category}
        </span>
        <button
          type="button"
          onClick={() => setSaved((v) => !v)}
          aria-label="收藏这条爆料"
          className={`absolute right-4 top-4 flex h-9 w-9 items-center justify-center rounded-full backdrop-blur transition-colors ${
            saved ? 'bg-accent-500 text-background-50' : 'bg-background-50/90 text-foreground-700 hover:text-primary-600'
          }`}
        >
          <i className={saved ? 'ri-bookmark-fill' : 'ri-bookmark-line'} />
        </button>
      </div>

      <div className="mt-5 flex flex-1 flex-col">
        <h3 className="font-heading text-lg font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-xl">
          {story.title}
        </h3>
        <p className="mt-3 font-body text-sm leading-relaxed text-foreground-600">
          {story.excerpt}
        </p>

        <div className="mt-auto flex items-center gap-4 border-t border-background-200/80 pt-4 font-label text-xs text-foreground-500">
          <span>{story.time}</span>
          <span className="flex items-center gap-1">
            <i className="ri-chat-3-line" />
            {story.comments}
          </span>
          <button
            type="button"
            onClick={() => setLiked((v) => !v)}
            className={`ml-auto flex items-center gap-1.5 rounded-full border px-3 py-1.5 transition-colors ${
              liked
                ? 'border-primary-300 bg-primary-50 text-primary-700'
                : 'border-background-300/70 text-foreground-600 hover:border-primary-300 hover:text-primary-600'
            }`}
          >
            <i className={liked ? 'ri-heart-3-fill' : 'ri-heart-3-line'} />
            {story.likes + (liked ? 1 : 0)}
          </button>
        </div>
      </div>
    </article>
  );
}

export default function TodayStories() {
  return (
    <section id="today" className="w-full bg-background-100/60 px-5 py-16 md:px-8 md:py-24">
      <div className="mx-auto w-full max-w-[1320px]">
        <SectionHeading
          index="01"
          eyebrow="今日猛料"
          title="今天被反复转发的三条线索"
          description="每条都尽量给出可核对的时间与来源，先看清楚，再决定要不要跟着情绪走。"
        />

        <div className="mt-10 grid grid-cols-1 gap-8 sm:grid-cols-2 md:mt-14 md:gap-10 lg:grid-cols-3">
          {todayStories.map((story) => (
            <StoryCard key={story.id} story={story} />
          ))}
        </div>
      </div>
    </section>
  );
}